import React from 'react';
import Image from '@/components/atoms/Image';

const LandingPageCardSection = ({ data }: any) => {
    const { sectionTitle, features } = data;

    return (
        <section className="w-full py-12 px-4 flex flex-col items-center bg-white">
            {sectionTitle && (
                <h2 className="text-center text-24 lg:px-32 3xl:px-[18rem] md:text-40 font-medium mb-12 mx-auto">
                    {sectionTitle}
                </h2>
            )}

                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-6 w-full 1xl:px-[8rem] 3xl:px-[16rem]">
                    {features?.map((feature: any, idx: number) => {
                        // Advanced layout: center any card that ends up alone in the last row for mobile
                        const mobileCols = 2;
                        const itemsInLastRow = features.length % mobileCols;
                        const isLast = idx === features.length - 1;
                        const shouldCenterMobile = isLast && itemsInLastRow === 1;
                        return (
                            <div
                                key={idx}
                                className={`flex flex-col items-center text-center bg-[#F7F5F2] rounded-2xl shadow-sm p-4 md:p-6 h-auto transition-all duration-300 ${shouldCenterMobile ? 'col-span-2 justify-self-center md:col-span-1' : ''}`}
                            >
                                <div className="flex items-center justify-center h-14 md:h-24 mb-2 md:mb-4">
                                    {feature.icon?.media?.file && (
                                        <Image
                                            src={feature.icon.media.file}
                                            alt={feature.icon.media.alt || feature.icon.media.name || ''}
                                            className="h-10 w-10 md:h-16 md:w-16 object-contain"
                                        />
                                    )}
                                </div>
                                <div className="flex items-center justify-center">
                                    {feature.description && (
                                        <p className="text-center font-normal md:text-[20px] text-[13px] md:leading-[25px] leading-[18px] md:tracking-[1.01px] tracking-[0.3px] text-gray-700">
                                            {feature.description}
                                        </p>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
        </section>
    );
};

export default LandingPageCardSection;
